import {Inject, LOCALE_ID, NgModule, Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'yesNo'})
export class YesNoPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale: string){
        // console.logByType'locale', locale);
    }

    transform(value: any, ...args: any[]): any {
        // console.logByType'locale', this.locale);
        return value ? 'Oui' : 'Non';
    }
}

@NgModule({
    declarations: [
        YesNoPipe,
    ],
    exports: [
        YesNoPipe,
    ]
})
export class YesNoPipeModule{}